import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { Heading2 } from '../../shared/Typography';
import {
  StyledBenefits,
  StyledBenefitsList,
  StyledItem,
  StyledItemIcon,
  StyledItemTitle
} from './JoinUsBenefits.styled';

const JoinUsBenefits: React.FC = () => {
  const { t } = useI18n('join-us');

  const benefits = [
    {
      id: 'flextime',
      icon: 'clock'
    },
    {
      id: 'holidays',
      icon: 'holidays'
    },
    {
      id: 'flexlocation',
      icon: 'remote'
    },
    {
      id: 'machine',
      icon: 'devices'
    },
    {
      id: 'schooling',
      icon: 'continuous-learning'
    },
    {
      id: 'speakers',
      icon: 'proactivity'
    },
    {
      id: 'retribution',
      icon: 'perk'
    },
    {
      id: 'teambuilding',
      icon: 'teamwork'
    },
    {
      id: 'care',
      icon: 'gift'
    }
  ];
  return (
    <StyledBenefits>
      <Heading2 editorial>{t('benefits.title')}</Heading2>
      <StyledBenefitsList>
        {benefits.map((b, i) => (
          <StyledItem key={i}>
            <StyledItemIcon
              src={getPublicPath('/images/icons/' + b.icon + '.svg')}
              alt=""
            />
            <StyledItemTitle>
              {t(`benefits.items.${b.id}.title`)}
            </StyledItemTitle>
            <p>{t(`benefits.items.${b.id}.desc`)}</p>
          </StyledItem>
        ))}
      </StyledBenefitsList>
    </StyledBenefits>
  );
};

export default JoinUsBenefits;
